<template>
     <!-- <div v-if="dataloader">
    <loader></loader>
  </div> -->
  <div class="preloader-container d-flex justify-content-center align-items-center">
     <div class="preloader text-center d-flex flex-column">
       <div>
         <!-- Add your loader here -->
         <img :src="portalLogo" alt="Loading..." style="width: 180px;">
       </div>
       <div class="text-center wid" v-if="roundtrip || oneway">
         <div class="row justify-content-center align-items-center front-text">
           <div class="col-5">
            <span class="fw-bold">{{ fromData }}</span>
            <span class="d-block p-2">{{ dedate }}</span>
          </div>

           <div class="col-2 px-0 px-lg-2" v-if="roundtrip">
         <img src="../assets/img/icon/round.png" alt="Loading..." style="width: 180px;">
           </div>
           <div class="col-2" v-else>
         <img src="../assets/img/icon/fly.png" alt="Loading..." style="width: 40px; height: 30px;">
           </div>
           <div class="col-5">
            <span class="fw-bold">{{ toData }}</span>
            <span class="d-block p-2" :class="{ disable: oneway }">{{ returnDate }}</span>
            
          </div>
         </div>
         <!-- <div class="row pb-1" v-if="roundtrip">
             <div class="col-5 deda"><span>{{ dedate }}</span></div>
             <div class="col-2"><span>&#160;</span></div>
             <div class="col-5 reda"><span>{{ returnDate }}</span></div>
         </div> -->
         <!-- <div class="row pb-1" v-if="oneway">
             <div class="col-12"><span>{{ dedate }}</span></div>
         </div> -->
         <!-- <div>
           <span v-if="roundtrip">RoundTrip</span>
           <span v-else>Oneway</span>
         </div>
         <div>{{ cabin }}</div>
         <div>{{  }}</div> -->
                <p class="text-center mt-3 py-2 f-size-14 fw-500" 
        style="color: grey;background: aliceblue;">
        {{ parseFloat(adultcount) + parseFloat(childcount) + parseFloat(infantcount) }} Passenger(s)
        / {{ classType }} / {{ travelType === "RT" ? "Round" : "Oneway"}}-Trip</p>
       </div>
       <div class="text-center wid"  v-if="multi">
         <div v-for="(data,index) in multiData.itinery" :key="index">
           <div class="row justify-content-center align-items-center pb-1 front-text">
             <div class="col-5"><span class="fw-bold">{{ data.from }}</span></div>
             <div class="col-2">
               <v-icon>mdi-arrow-right</v-icon>
               <!-- <p class="f-size-14 fw-500"> {{ getDate(data.depdate) }}</p> -->
             </div>
             <div class="col-5"><span class="fw-bold">{{ data.to }}</span></div>
           </div>
           <div class="row">
             <div class="col-12 text-center"><p>{{ getDate(data.departDate)}}</p></div>
           </div>
         </div>
         <p class="text-center py-2 f-size-14 fw-500" 
            style="color: grey;background: aliceblue;">
            {{parseFloat(adultcount) + parseFloat(childcount) + parseFloat(infantcount) }} Passenger(s)
             / {{ classType }} / Multicity</p>
       </div>
      <div>
    <img src="../assets/img/icon/flight_fetch.gif" alt="" srcset="">
   </div>
   </div>
   </div>
 </template>
 
 <script>
// import loader from "@/components/loaderComponent.vue";
 import moment from "moment";
 import { getConfigDataFromLocalStorage } from "@/localStorageData/localStorageUtil.js";
// import { DisabledTime } from "@vuepic/vue-datepicker";
 export default {
   props: {
     searchCase: String,
   },
  //    components: {
  //   loader,
  //   // pageError,
  // },
   data() {
     return {
      // dataloader : true,
       portalLogo: "",
       fromData: "",
       toData: "",
       dedate: "",
       returnDate: "",
       tripType: "",
       adultcount:"", 
       childcount: "",
       infantcount: "",
       classType: "",
 
       multi: false,
       roundtrip: false,
       oneway: false,
 
       multiData:[],
       searchData:"",
       // items: [
       //   {
       //     src: require("@/assets/caro1.jpg"),
       //   },
       // ],
       
       progloader:true,
     };
   },
 
 
   methods: {
// checkTabIdAndLoad() {
//       this.dataloader = true; 
//   const startTime = Date.now(); // get start time in milliseconds

//   const interval = setInterval(() => {
//     const tabId = sessionStorage.getItem("tabId");

//     if (tabId) {
//       const endTime = Date.now(); // time when tabId is found
//       const durationMs = endTime - startTime;
//       const durationSec = Math.floor(durationMs / 1000);
//       const durationMin = (durationSec / 60).toFixed(2);

//       console.log(`tabId fetched after ${durationSec} seconds (${durationMin} minutes)`);

//       this.loadSearchData();
//       this.dataloader = false;

//       clearInterval(interval);
//     }
//   }, 200); // check every 200ms
 
// },
checkTabIdAndLoad() {
    const interval = setInterval(() => {
      const tabId = sessionStorage.getItem("tabId");
      if (tabId) {
        this.loadSearchData();
        clearInterval(interval);
      }
    }, 20); // check every 200ms
  },
loadSearchData() {
  const tabId = sessionStorage.getItem("tabId");
  const tripType = this.$route.query.tripType;
  let key = "";

  if (tripType === "RT" || tripType === "OW") {
    key = tripType === "RT"
      ? `searchedData-round-${tabId}`
      : `searchedData-oneway-${tabId}`;
    this.oneway = tripType === "OW";
    this.roundtrip = tripType === "RT";
  } else if (tripType === "MC") {
    key = `searchedData-multicity-${tabId}`;
    this.multi = true;
  }

  const storedData = localStorage.getItem(key);

  if (storedData) {
    this.dataloader = false;
    const parsedData = JSON.parse(storedData);

    // 👇 Check if key fields are available before hiding loader
    if (
      (this.multi && parsedData.itinery && parsedData.itinery.length > 0) ||
      (!this.multi && parsedData.from && parsedData.to && parsedData.dedate)
    ) {
      // ✅ Assign only when data is valid
      if (this.multi) {
        this.multiData = parsedData;
        this.adultcount = parsedData.adult;
        this.childcount = parsedData.child;
        this.infantcount = parsedData.infant || parsedData.infrant;
        this.classType = parsedData.class;
      } else {
        this.searchData = parsedData;
        this.fromData = parsedData.from;
        this.toData = parsedData.to;
        this.dedate = moment(parsedData.dedate).format("DD MMM-YYYY");

        if (tripType === "RT") {
          this.returnDate = moment(parsedData.redate).format("DD MMM-YYYY");
        }

        this.adultcount = parsedData.adult;
        this.childcount = parsedData.child;
        this.infantcount = parsedData.infant || parsedData.infrant;
        this.classType = parsedData.class;
        this.travelType = tripType;
      }

      // ✅ Only now, hide loader
      this.dataloader = false;
    // } else {
    //   // ❌ Data not ready yet
    //   console.log("Data incomplete, waiting...");
    //   this.dataloader = true;
    // }
  } 
  // else {
  //   console.log("No stored data found.");
  //   this.dataloader = true;
  // }
}
},

 
     getDate(data){
       return moment(data).format("DD MMM-YYYY")
     },
     getConfigFunc() {
       const getConfigData = getConfigDataFromLocalStorage();
 
       console.log(getConfigData, "LOADERRR");
 
       if (getConfigData) {
         this.portalLogo = getConfigData.payload.portal_configuration.logo_path;
         console.log(this.portalLogo,'asdasdaportalLogo');
         
       }
     },
     
   },
   watch: {
    tabId(newVal) {
    if (newVal) this.loadSearchData();
  },
     searchCase(newValue) {
       // this.searchData = newValue;
       if (newValue) {
         this.loadSearchData(); 
       }
     },
   },
 
   
mounted() {
  this.getConfigFunc();
  this.checkTabIdAndLoad(); // this will trigger loadSearchData() when tabId ready
  },

  //  created(){
  //    this.loadSearchData();
  //  }
 };
 </script>
 
 <style scoped>
 .preloader-container {
   height: 350px;
   display: flex;
   justify-content: center;
   align-items: center;
 }
 
 .preloader {
   text-align: center;
 }
 .wid
 {
   width: 60%;
   margin-top: 50px;
 }
 .preloader {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 10000;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    background: #fff;
    transition: .3s all ease;
}
 @media only screen and (max-width: 768px){
 .wid
 {
     width: 85%;
 }
 .deda
 {
   margin-left: -8px;
 }
 .reda{
   padding-left: 45px;
   /* padding: 0px !important; */
 }
 .preloader {
   text-align: center;
   margin-top: -20px;
   width: 380px;
   padding: 0px;
 }
 }
.front-text{
  font-size: 16px;
} 
 @media only screen and (max-width: 768px){
  .front-text{
  font-size: 13px;
} 
 }
 </style>